import Plotly from 'plotly.js-dist-min';

const getYAxes = (cycleData, index) => {
  let y = [];
  cycleData.forEach(el => {
    y.push(el.value[index]);
  });
  return y;
};
const  configOptions = {
  editable: false,
  displaylogo: false,
  displayModeBar: false,
  scrollZoom: false,
  showLink: false,
  modeBarButtonsToRemove: [
    'sendDataToCloud',
    'zoom2d',
    'pan',
    'pan2d',
    'autoScale2d',
    'lasso2d',
    'autoScale2d',
    'resetScale2d',
    'toggleSpikelines',
    'dragmode',
  ],
};
export const generateCurrentVsLast = props => {
  if (props?.data?.type === 'LIVE') {
  const currentCycle = props?.data?.reportData?.metrics_for_graph;
  const kpiList = props?.kpiList?.length > 0 ? props?.kpiList : [];
  const primaryKpi = props?.data?.primaryKpi;
  const secondryKpi = props?.data?.secondaryKpi;
  let primaryFamilyName, secondryFamilyName;
  const changeMetricsName = (key) => {
    const metric = kpiList?.filter(x => x?.sys_id === key)[0];
    let data_type = metric?.data_type;
    let type = '';
    if(data_type === 'PERCENTAGE'){
      type = '(%) ';
    } else if (data_type === 'CURRENCY') {
      type = `(${props?.data?.currency}) `;
    }
    return type ? type + metric?.KPI_Metric : metric?.KPI_Metric;
  };
  kpiList.map(o => {
    if (o.sys_id === primaryKpi) {
      primaryFamilyName = o.metric_family;
    } else if (o.sys_id === secondryKpi) {
      secondryFamilyName = o.metric_family;
    }
  });
  let primaryFamily = [],
    secondryFamily = [];
  kpiList.map(item => {
    if (item.metric_family === primaryFamilyName) {
      primaryFamily.push(item);
    } else if (item.metric_family === secondryFamilyName) {
      secondryFamily.push(item);
    }
  });
  let primaryGraph = [],
    secondaryGraph = [];
  primaryFamily.forEach(el => {
    if (el.KPI_type === 'Volume' || el.KPI_type === 'Efficiency') {
      let data_type = el?.data_type;
      let type = '';
      if(data_type === 'PERCENTAGE'){
        type = '(%) ';
      } else if (data_type === 'CURRENCY') {
        type = `(${props?.data?.currency}) `;
      }
      let name = type ? type + el?.KPI_Metric : el?.KPI_Metric;
      primaryGraph.push(name);
    }
  });
  secondryFamily.forEach(el => {
    if (el.KPI_type === 'Volume' || el.KPI_type === 'Efficiency') {
      let data_type = el?.data_type;
      let type = '';
      if(data_type === 'PERCENTAGE'){
        type = '(%) ';
      } else if (data_type === 'CURRENCY') {
        type = `(${props?.data?.currency}) `;
      }
      let name = type ? type + el?.KPI_Metric : el?.KPI_Metric;
      secondaryGraph.push(name);
    }
  });
  let cycleData = [];
  let dataforX = [];
  let currentCycleDate = props?.data?.reportingStartDate + ' - ' + props?.data?.reportingEndDate;
  dataforX.push(currentCycleDate);
  cycleData.push({ key: props?.data?.reportData?.cycleId, value: [] });
  let previousCycleData = props?.data?.previousCyclesData.reverse();
  // previousCycleData = previousCycleData.slice(0, 8);
  let count = 1;
  if (previousCycleData?.length > 0) {
    previousCycleData.forEach(el => {
      if(el?.metrics_for_graph?.length > 0 && count < 9) {
      count++;
      if(el?.startDate && el?.endDate) {
        dataforX.push(el?.startDate?.substring(0, 10) + ' - ' + el?.endDate?.substring(0, 10));
        cycleData.push({ key: el.cycleId, value: [] });
      }
    }
    });
  } else {
    props?.setCurrentvsLastMsg(true);
  }
  if(currentCycle?.length > 0) {
  const metric = [];
  
  currentCycle?.forEach(el => {
    let row = {};
    row.metric = changeMetricsName(el?.key);
    const currentvalue = el.value.trim();
    row.current_cycle = currentvalue;
    metric.push(row.metric);
    cycleData.find(o => o.key === props?.data?.reportData?.cycleId).value.push(row.current_cycle);
    previousCycleData.forEach(prev => {
      const value = prev?.metrics_for_graph.filter(x => x?.key === el?.key)[0]?.value;
        cycleData.find(o => o.key === prev.cycleId)?.value.push(value);
    });
  });
  let traces = [];
  let y1 = 0;
  metric.map((el, index) => {
    if (el.includes('Media Spend') || el.includes('CPM')) {
      y1 = y1 + 1;
      let trace = {
        x: dataforX,
        y: getYAxes(cycleData, index),
        name: el,
        width: 0.1,
        opacity: 0.5,
        offsetgroup: y1,
        type: 'bar',
        yaxis: 'y' + y1,
      };
      traces.push(trace);
    }
  });
  let traces2 = [];
  let y2 = 0;
  metric.map((el, index) => {
    if (primaryGraph.includes(el)) {
      y2 = y2 + 1;
      let trace = {
        x: dataforX,
        y: getYAxes(cycleData, index),
        name: el,
        width: 0.1,
        offsetgroup: y2 + 1,
        type: 'bar',
        opacity: 0.5,
        yaxis: 'y' + y2,
      };
      traces2.push(trace);
    }
  });
  let traces3 = [];
  let y3 = 0;
  if(secondaryGraph?.length > 0) {
    metric.map((el, index) => {
      if (secondaryGraph.includes(el)) {
        y3 = y3 + 1;
        let trace = {
          x: dataforX,
          y: getYAxes(cycleData, index),
          name: el,
          width: 0.1,
          opacity: 0.5,
          offsetgroup: y3 + 1,
          type: 'bar',
          yaxis: 'y' + y3,
        };
        traces3.push(trace);
      }
    });
  }
  

  let commonLayout = {
    title: 'Current vs last',
    xaxis: { domain: [0.1, 0.8], tickangle: 20, type: 'category' },
    barmode: 'group',
    margin: { t: 50, r: 5, l: 5, b: 100 },
    yaxis: {
      titlefont: { color: '#1f77b4' },
      tickfont: { color: '#1f77b4' },
    },
    yaxis2: {
      titlefont: { color: '#ff7f0e' },
      tickfont: { color: '#ff7f0e' },
      overlaying: 'y',
      side: 'right',
    },
  };
  let data = [...traces];
  const layout1 = JSON.parse(JSON.stringify(commonLayout));
  layout1.title = 'Media spend and CPM';
  layout1.yaxis.title = traces[0]?.name;
  layout1.yaxis2.title = traces[1]?.name;
  Plotly.newPlot('current_vs_last', data, layout1, configOptions,{ responsive: true });
  Plotly.newPlot('current_vs_last_ss', data, layout1, configOptions,{ responsive: true });

  let data2 = [...traces2];
  const layout2 = JSON.parse(JSON.stringify(commonLayout));
  layout2.title = 'Primary Kpis';
  layout2.yaxis.title = traces2[0]?.name;
  layout2.yaxis2.title = traces2[1]?.name;
  
  Plotly.newPlot('current_vs_last2', data2, layout2, configOptions,{ responsive: true });
  Plotly.newPlot('current_vs_last2_ss', data2, layout2, configOptions,{ responsive: true });

  if(secondaryGraph?.length > 0) {
    let data3 = [...traces3];
    const layout3 = JSON.parse(JSON.stringify(commonLayout));
    layout3.title = 'Secondary Kpis';
    layout3.yaxis.title = traces3[0]?.name;
    layout3.yaxis2.title = traces3[1]?.name;
    Plotly.newPlot('current_vs_last3', data3, layout3, configOptions,{ responsive: true });
    Plotly.newPlot('current_vs_last3_ss', data3, layout3, configOptions,{ responsive: true });
  }
  
  const current_vs_last = document.getElementById('current_vs_last');
  const current_vs_last2 = document.getElementById('current_vs_last2');
  const current_vs_last3 = document.getElementById('current_vs_last3');

  //  Listen to the `plotly_resytle` event to show/hide yaxis as required
  current_vs_last.on('plotly_restyle', ([updatedData, tracesTouched]) => {
    restyle(updatedData, tracesTouched, 'current_vs_last');
  });
  current_vs_last2.on('plotly_restyle', ([updatedData, tracesTouched]) => {
    restyle(updatedData, tracesTouched, 'current_vs_last2');
  });
  if(secondaryGraph?.length > 0) {
    current_vs_last3.on('plotly_restyle', ([updatedData, tracesTouched]) => {
      restyle(updatedData, tracesTouched, 'current_vs_last3');
    });
  }
  const restyle = (updatedData, tracesTouched, id) => {
    const yIndex = tracesTouched[0] === 0 ? 'yaxis.visible' : 'yaxis2.visible';
    const visiblity = updatedData.visible[0] === true ? true : false;
    Plotly.relayout(id, { [yIndex]: visiblity });
  };
} else {
  props?.setCurrentvsLastNodata(true);
}
  }
};
